export default {
      id: "unarchive-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#unarchive-usage",
      toString: function () {
        return this.url;
      }
    }